<template>
    <div
        :style="style"
        class="rkm-sidebar"
    >
        <div class="rkm-sidebar-wrap">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        style() {
            return {
                transform: this.open ? 'translateX(0%)' : 'translateX(-100%)',
            }
        },
    },
    props: {
        open: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-sidebar {
    background-color: #ffffff;
    box-shadow: 5px 0 5px -5px #999999;
    height: 100vh;
    padding: 5px 0px;
    position: fixed;
    top: 56px;
    transition-duration: 0.2s;
    transition-property: transform, visibility, width;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    width: 240px;
    z-index: 999;
}
.rkm-sidebar-wrap {
    display: flex;
    flex-direction: column;
    height: calc(100% - 56px);
    justify-content: space-between;
    overflow: auto;
}
.rkm-sidebar-wrap::-webkit-scrollbar{
    background: transparent;
    width: 5px;
}
.rkm-sidebar-wrap::-webkit-scrollbar-track{
    background: none;
    box-shadow: none;
}
.rkm-sidebar-wrap::-webkit-scrollbar-thumb{
    background: rgba(0,0,0,0.3);
    border-radius: 10px;
}
</style>